import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path d="M18 2v7H6V2h12zm-2 2H8v3h8V4z" />
    <path d="M22 7v13h-4v-2h2V9H4v9h2v2H2V7h20z" />
    <path d="M18 14v9H6v-9h12zm-2 2H8v5h8v-5zM14 10h4v2h-4z" />
  </svg>
);
